import styled from 'styled-components';

export const LastUpdatedDateWrapper = styled.div`
  font-size: 12px;
  line-height: 21px;
  color: ${({ theme }): string => theme.admanColors!.gray.light.bg3[3]};
`;
